/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CreateAgentAssistant_agentUser = {
    readonly agent: {
        readonly ufid: string;
    };
    readonly " $refType": "CreateAgentAssistant_agentUser";
};
export type CreateAgentAssistant_agentUser$data = CreateAgentAssistant_agentUser;
export type CreateAgentAssistant_agentUser$key = {
    readonly " $data"?: CreateAgentAssistant_agentUser$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"CreateAgentAssistant_agentUser">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateAgentAssistant_agentUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Agent",
      "kind": "LinkedField",
      "name": "agent",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ufid",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AgentUser",
  "abstractKey": null
};
(node as any).hash = '59f9bd3a585824b643506413fa0554d8';
export default node;
